import type React from 'react';
import { useEffect } from 'react';

import useErrorHandling from '@swf/core/hooks/useErrorHandling';
import useWizardContext from '@swf/core/hooks/useWizardContext';

const WizardAdapter: React.FC = () => {
  const { error } = useWizardContext();
  const { addError } = useErrorHandling();

  useEffect(() => {
    if (error) {
      addError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return null;
};

export default WizardAdapter;
